import React from 'react';
import { OnamandEidCelebration2026 } from '../views';


const SchoolProgrampage = () => {
  return <OnamandEidCelebration2026/>;
};

export default SchoolProgrampage;